export default "__VITE_ASSET__yZXGsz73__"